import React, { useState } from 'react';
import SelectBox from 'devextreme-react/select-box';
import ruMessages from 'devextreme/localization/messages/ru.json';
import deMessages from 'devextreme/localization/messages/de.json';

import { locale, loadMessages, formatMessage } from 'devextreme/localization';

const initMessages = () => {
    loadMessages(ruMessages);
    loadMessages(deMessages);
  }

const locales = [
  {
    Name: 'English',
    Value: 'en',
  },
  {
    Name: 'Deutsch',
    Value: 'de',
  },
  {
    Name: 'Русский',
    Value: 'ru',
  },
];
const selectBoxInputAttr = { id: 'selectInput' };

const SelectLanguage = ({ ...props }) => {
    const getSessionLocale = () => {
        const storageLocale = sessionStorage.getItem('locale');
        return storageLocale != null ? storageLocale : 'ru';
    }

    const setLocale = (savingLocale) => {
        setSessionLocale(savingLocale);
        locale(savingLocale);
        sessionStorage.setItem('locale', savingLocale);
    }

    const [sessionLocale, setSessionLocale] = useState(getSessionLocale());
    initMessages();
    locale(sessionLocale);

const changeLocale = (e) => {
    setLocale(e.value);
    document.location.reload();
  }


    return (
            <SelectBox items={locales}
              valueExpr="Value"
              displayExpr="Name"
              value={sessionLocale}
              onValueChanged={changeLocale}
              inputAttr={selectBoxInputAttr} 
              {...props}
            />
    );
}
export default React.memo(SelectLanguage);
